import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const JobBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/job/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const stepBaseUrl = baseDeployUrl + '/api/1.0/flow/step/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getSteps = () => {
  return axios.request({
    url: stepBaseUrl + 'list',
    headers: baseHeaders,
    method: 'get'
  })
}

// 编辑保存角色信息
export const changeStep = (data, id) => {
  let url = stepBaseUrl
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}
